import { render, staticRenderFns } from "./IconManage.vue?vue&type=template&id=5650931e&scoped=true"
import script from "./IconManage.vue?vue&type=script&lang=js"
export * from "./IconManage.vue?vue&type=script&lang=js"
import style0 from "./IconManage.vue?vue&type=style&index=0&id=5650931e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5650931e",
  null
  
)

export default component.exports